<div class="w-100 h-100 overflow-hidden" [hidden]="!this.chart">
    <canvas [id]="conf.id"></canvas>
</div>
  